import { userConstants } from "../../constant";

export function savedSearches(state = [], action) {
  switch (action.type) {
    case userConstants.GET_SAVED_SEARCHES:
      return action.payload;
    case userConstants.SAVE_SEARCH:
      return [action.payload, ...state];
    case userConstants.DELETE_SAVED_SEARCH:
      return state.filter((s) => s.id !== action.payload);
    case userConstants.TOGGLE_SAVED_SEARCH_NOTIFY:
      return state.map((s) =>
        s.id === action.payload.id ? action.payload : s
      );
    default:
      return state;
  }
}
